import { alpha, Typography, Box, styled } from "@mui/material";


export const BoxStyle = styled(Box, {
    shouldForwardProp: (prop) => prop !== "open" && prop !== "selected",
})<{ open?: boolean; selected?: boolean }>(({
    theme, open, selected
}) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "185px",
    cursor: "pointer",
    transition: "background 0.3s ease",
    borderRadius: "8px",
    marginBottom: "14px",
    background: selected ? alpha("#B7B7B7", 0.15) : open ? alpha("#B7B7B7", 0.15) : "transparent",
    '&:hover': {
        background: alpha("#B7B7B7", 0.15),
    },
}));

export const TypographyStyle = styled(Typography)(({ theme }) => ({
    minWidth: "135px",
    fontSize: "14px",
    lineHeight: "22px",
    fontFamily: "Fixel Display, sans-serif",
    padding: "9px 16px",
    borderBottom: "2px solid transparent",
    borderRadius: "8px",
}));

export const TypographyMenuStyle = styled(Typography, { shouldForwardProp: (prop) => prop !== "selected" })<{ selected?: boolean; }>(({ theme, selected }) => ({
    minWidth: "135px",
    fontSize: "14px",
    lineHeight: "22px",
    fontFamily: "Fixel Display, sans-serif",
    padding: "9px 16px",
    borderBottom: "2px solid transparent",
    transition: "background 0.3s ease",
    borderRadius: "8px",
    background: selected ? alpha("#B7B7B7", 0.15) : "transparent",
    '&:hover': {
        background: alpha("#B7B7B7", 0.15)
    },
}));
